import React from 'react';
import "./_solutionCertificate.scss";
const CERTS = [
    <span className="sic-certs-none"></span>,
    null, // <span className="sic-certs-sp" title="Solution Partner"></span>,
    null, // <span className="sic-certs-preferred" title="Preferred Solution Partner"></span>,
    null, // <span className="sic-certs-strategic" title="Strategic Solution Partner"></span>,
    <span className="sic-certs-compatible" title="Cisco Compatible"></span>
];

const cert = (props) => CERTS[props.index] || null;

export default cert;